/* eslint-disable @typescript-eslint/no-explicit-any */

import { initChat } from '../../utils/sf-utils/chat-init';
import { addChatEventListeners } from './sf-event-listeners';
import { updateSFInitConfig } from './sf-config-override';
import { IUserInfo } from '../../utils/api-utils/user-profile-api';
import { WindowType } from '../../types/global-window-type';
import { getChatConfig } from '../../utils/app-utils/chat-config-utils';

declare const window: WindowType;

const initEmbeddedMessaging = (context: any, userInfo?: IUserInfo) => {
  try {
    console.info({ context });
    /** Set window object */
    window.is_MIAW_Window = true;
    /** Override default config of miaw chat */
    updateSFInitConfig();
    /** Add event listeners to Chat events */
    addChatEventListeners(context, userInfo);
    /** Init Chat based on the context */
    initChat();
  } catch (err) {
    console.error('Error loading Embedded Messaging: ', err);
  }
};

/** Fn to load SF script */
export const initSFChat = (context: any, userInfo?: IUserInfo) => {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.onload = () => {
    initEmbeddedMessaging(context, userInfo);
  };
  const { sfConfig } = getChatConfig();
  script.src = sfConfig.initURL;
  document.getElementsByTagName('body')[0].appendChild(script);
};
